<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-sunrise`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M45 38a1 1 0 011 1v2a1 1 0 01-1 1H3a1 1 0 01-1-1v-2a1 1 0 011-1h42zM24 13c9.941 0 18 8.059 18 18 0 .676-.037 1.344-.11 2h-4.032A14.12 14.12 0 0038 31c0-7.732-6.268-14-14-14s-14 6.268-14 14c0 .673.047 1.34.141 1.997V33h-4.03A18.178 18.178 0 016 31c0-9.941 8.059-18 18-18zm23 15a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2a1 1 0 011-1h2zM3 28a1 1 0 011 1v2a1 1 0 01-1 1H1a1 1 0 01-1-1v-2a1 1 0 011-1h2zm37.264-15.678l1.414 1.415a1 1 0 010 1.414l-1.414 1.414a1 1 0 01-1.415 0l-1.414-1.414a1 1 0 010-1.415l1.414-1.414a1 1 0 011.415 0zm-31.113 0l1.414 1.415a1 1 0 010 1.414l-1.414 1.414a1 1 0 01-1.414 0l-1.415-1.414a1 1 0 010-1.415l1.415-1.414a1 1 0 011.414 0zM25 6a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1V7a1 1 0 011-1h2z"/></svg>
</template>
<script>

export default {
  name: 'IconSunrise',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
